export class Estados {
    public estados =
[
{estado: 'Acre', uf: 'AC', codigoibge: '12', regiao: 'NORTE'},
{estado: 'Alagoas', uf: 'AL', codigoibge: '27', regiao: 'NORDESTE'},
{estado: 'Amapá', uf: 'AP', codigoibge: '16', regiao: 'NORTE'},
{estado: 'Amazonas', uf: 'AM', codigoibge: '13', regiao: 'NORTE'},
{estado: 'Bahia', uf: 'BA', codigoibge: '29', regiao: 'NORDESTE'},
{estado: 'Ceará', uf: 'CE', codigoibge: '23', regiao: 'NORDESTE'},
{estado: 'Distrito Federal', uf: 'DF', codigoibge: '53', regiao: 'CENTROOESTE'},
{estado: 'Espírito Santo', uf: 'ES', codigoibge: '32', regiao: 'SUDESTE'},
{estado: 'Goiás', uf: 'GO', codigoibge: '52', regiao: 'CENTROOESTE'},
{estado: 'Maranhão', uf: 'MA', codigoibge: '21', regiao: 'NORDESTE'},
{estado: 'Mato Grosso', uf: 'MT', codigoibge: '51', regiao: 'CENTROOESTE'},
{estado: 'Mato Grosso do Sul', uf: 'MS', codigoibge: '50', regiao: 'CENTROOESTE'},
{estado: 'Minas Gerais', uf: 'MG', codigoibge: '31', regiao: 'SUDESTE'},
{estado: 'Pará', uf: 'PA', codigoibge: '15', regiao: 'NORTE'},
{estado: 'Paraíba', uf: 'PB', codigoibge: '25', regiao: 'NORDESTE'},
{estado: 'Paraná', uf: 'PR', codigoibge: '41', regiao: 'SUL'},
{estado: 'Pernambuco', uf: 'PE', codigoibge: '26', regiao: 'NORDESTE'},
{estado: 'Piauí', uf: 'PI', codigoibge: '22', regiao: 'NORDESTE'},
{estado: 'Rio de Janeiro', uf: 'RJ', codigoibge: '33', regiao: 'SUDESTE'},
{estado: 'Rio Grande do Norte', uf: 'RN', codigoibge: '24', regiao: 'NORDESTE'},
{estado: 'Rio Grande do Sul', uf: 'RS', codigoibge: '43', regiao: 'SUL'},
{estado: 'Rondônia', uf: 'RO', codigoibge: '11', regiao: 'NORTE'},
{estado: 'Roraima', uf: 'RR', codigoibge: '14', regiao: 'NORTE'},
{estado: 'Santa Catarina', codigoibge: '42', uf: 'SC', regiao: 'SUL'},
{estado: 'São Paulo', uf: 'SP', codigoibge: '35', regiao: 'SUDESTE'},
{estado: 'Sergipe', uf: 'SE', codigoibge: '28', regiao: 'NORDESTE'},
{estado: 'Tocantins', uf: 'TO', codigoibge: '17', regiao: 'NORTE'}
]
}
